import axios from "axios";
import { BdcBlogActions } from "./blogAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

const getAdminURL = (state) => {
  return state.environnment.environmentLists.adminBaseURL;
};

export const createBlogAsync = (
  detail,
  setSubmitting,
  resetForm,
  redirectBack
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(BdcBlogActions.createBlogStart());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/bdcblog/create`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: detail,
      });
      if (data.code === 200 && data.status) {
        dispatch(BdcBlogActions.createBlogSuccess(data.data));
        setSubmitting(false);
        // resetForm();
        redirectBack();
        return dispatch(showSuccessSnackbar("success", data.message, 3000));
      }
      dispatch(BdcBlogActions.createBlogError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
      setSubmitting(false);
    } catch (error) {
      dispatch(BdcBlogActions.createBlogError());
      setSubmitting(false);
      // resetForm();
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const getAllBlogAsync = (searchBy, searchText, status) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(BdcBlogActions.getAllBlog());
      let { skip, limit } = getState().blog;
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/bdcblog/getAll?skip=${skip}&limit=${limit}&column=${searchBy}&search=${searchText}&status=${status}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(BdcBlogActions.getAllBlogSuccess(data.data));
      }
      dispatch(BdcBlogActions.getAllBlogError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      console.log("Error: ", error);
      dispatch(BdcBlogActions.getAllBlogError());
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const getBlogDetailAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(BdcBlogActions.getBlogDetail());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/bdcblog/getDetail/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(BdcBlogActions.getBlogDetailSuccess(data.data));
      }
      dispatch(BdcBlogActions.getBlogDetailError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      dispatch(BdcBlogActions.getBlogDetailError());
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const updateBlogAsync = (
  values,
  setSubmitting,
  resetForm,
  redirectBack
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      //let { _id } = getState().auth.user;
      let { selectedBlog } = getState().blog;
      dispatch(BdcBlogActions.updateBlogStart());
      const { data } = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/bdcblog/update/${selectedBlog._id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });

      if (data.code === 200 && data.status) {
        dispatch(BdcBlogActions.updateBlogSuccess(data.data));
        setSubmitting(false);
        resetForm();
        redirectBack();
        return dispatch(showSuccessSnackbar("success", data.message, 3000));
      }
      dispatch(BdcBlogActions.updateBlogError());
      setSubmitting(false);
      return dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      dispatch(BdcBlogActions.updateBlogError(error));
      setSubmitting(false);
      resetForm();
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const deleteBlogAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(BdcBlogActions.deleteBlogStart());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/bdcblog/remove/${id}`,
        method: "delete",
      });
      if (data.code === 200) {
        dispatch(BdcBlogActions.deleteBlogSuccess(data.data));
        return dispatch(showSuccessSnackbar("success", data.message, 3000));
      }
      dispatch(BdcBlogActions.deleteBlogError());
      return dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      console.log("Error: ", error);
      dispatch(BdcBlogActions.deleteBlogError());
      dispatch(
        showSuccessSnackbar(
          "error",
          "Error while updating.Please try again after sometime..",
          3000
        )
      );
    }
  };
};

export const getBlogLogsAsync = (blogId) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(BdcBlogActions.getBlogLogs());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/bdcblog/getLogs/${blogId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(BdcBlogActions.getBlogLogsSuccess(data.data));
      }
      dispatch(BdcBlogActions.getBlogLogsError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      dispatch(BdcBlogActions.getBlogLogsError());
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const updateSelectedBlogStatusAsync = (ids, status) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      const { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/bdcblog/updateSelectedStatus`,
        method: "put",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          ids,
          status,
        },
      });
      if (data.code === 200) {
        dispatch(
          showSuccessSnackbar(
            "success",
            "Status updated successfully",
            3000,
          ),
        );
        return true;
      }
      dispatch(showSuccessSnackbar("error", data.message, 3000));
      return false;
    } catch (error) {
      console.log("Error: ", error);
      dispatch(
        showSuccessSnackbar(
          "error",
          "Error while updating status. Please try again after sometime.",
          3000,
        ),
      );
      return false;
    }
  };
};
